// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_yeTcD","icon":"index_icon_2dZ_p","title":"index_title_D1wRK","line":"index_line_2Jq4h"};